import React from "react";
import { DatePicker } from "antd";
export default function FiltreWithTemplate({
  getYear,
  filtreWith,
  onChange,
  data,
  setData,
}) {
  return (
    <>
      {filtreWith === "year" && (
        <DatePicker
          allowClear={false}
          onChange={onChange}
          value={getYear}
          picker="year"
        />
      )}
      {filtreWith === "periode" && (
        <section className="d-flex gap-2 align-items-center">
          <input
            min={new Date().toISOString().slice(0, 10)}
            style={{ width: "auto", height: "20px" }}
            type="date"
            onChange={(e) => setData({ ...data, date_debut: e.target.value })}
            value={data.date_debut}
          />
          <span>Au</span>
          <input
            style={{ width: "auto", height: "20px" }}
            type="date"
            onChange={(e) => setData({ ...data, date_fin: e.target.value })}
            value={data.date_fin}
          />
        </section>
      )}
    </>
  );
}
